module.exports = __webpack_public_path__ + "static/img/imagination_02.9899927.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/corona/imagination_02.png
// module id = 8dRj
// module chunks = 0